module.exports = "<i class=\"spark-icon--fill spark-icon-close-circle circle-close-icon\" data-click=true uid={{::uid}} field-id={{::fieldId}}></i>";